// var program = require('commander');
// var git = require('nodegit');
//
// program
//     // .option('-f, --force', 'force installation')
//     .parse(process.argv);
//
//
// console.log("Creating Zips..");
//
// var pkgs = program.args;
